import styled from 'styled-components'

export const CategoryContainer = styled.div`
  padding: 0 0 3.75rem;

  white-space: pre-wrap;
`

export const CategoryModuleSingleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .filters {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 1rem;
  }

  .button-mustShowCatalog {
    text-align: left;
  }

  select {
    margin-left: 10px;
    height: 40px;
    padding: 0 10px;
  }

  @media (max-width: 768px) {
    .filters {
      flex-wrap: wrap;
      justify-content: center;
      label {
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`
